import { useQuery } from '@tanstack/react-query'
import { getJobVacancies, getJobVacancyDetail, getJobVacancyFilters } from "./api"

export const useQueryJobVacancies = (params = {}, options = {}) => {
  return useQuery({
    queryKey: ['job-vacancies', params],
    queryFn: () => getJobVacancies(params),
    ...options
  })
}

export const useQueryJobVacancyFilters = (options = {}) => {
  return useQuery({
    queryKey: ['job-vacancy-filters'],
    queryFn: () => getJobVacancyFilters(),
    ...options
  })
}

export const useQueryJobVacancyDetail = (id, options = {}) => {
  return useQuery({
    queryKey: ['job-vacancy-detail', id],
    queryFn: () => getJobVacancyDetail(id),
    enabled: !!id,
    ...options
  })
}
